import React from "react";

import css from "./SmallCallToAction.module.scss";

type Props = {
  content: string;
  buttonLink: string;
  suppliers?: number;
  ctaContent: string;
};

export default function CallToAction({ content, suppliers, buttonLink, ctaContent }: Props) {
  return (
    <div className={css.container}>
      <div className={css.leftColumn}>
        {suppliers && (
          <p className={css.suppliers}>{suppliers} Suppliers have already viewed this notice</p>
        )}
        <p>{content}</p>
      </div>
      <div className={css.rightColumn}>
        <button onClick={() => window.open(buttonLink, "_blank")}>{ctaContent}</button>
      </div>
    </div>
  );
}
